import { render, staticRenderFns } from "./TechnicalSpecification.vue?vue&type=template&id=675152cc&scoped=true&"
import script from "./TechnicalSpecification.vue?vue&type=script&lang=js&"
export * from "./TechnicalSpecification.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalSpecification.vue?vue&type=style&index=0&id=675152cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675152cc",
  null
  
)

export default component.exports